// extracted by mini-css-extract-plugin
module.exports = {"Container":"TitleWithPathHeader_Container__1gDUN","Title":"TitleWithPathHeader_Title__1_58d"};